module.exports = __webpack_public_path__ + "static/img/5.ccc5830.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/4/5.png
// module id = 244
// module chunks = 0